<template>
  <div v-if="options.length">
    <div class="body-2">
      <span v-if="selectedId">Оплачено на счет</span>
      <span
          v-else
          class="red--text">
        Необходимо выбрать счет *
      </span>
    </div>

    <div v-if="current">
      <div
          @click="current = null"
      >
        <v-list-item
            class="px-0"
            dese
        >
          <v-list-item-avatar
              class="my-1"
              size="30"
          >
            <v-icon class="accent--text">{{getTypeLocalized(current).icon}}</v-icon>
          </v-list-item-avatar>
          <v-list-item-content class="py-2">
            <v-list-item-title class="accent--text text-decoration-underline">{{getValue(current)}}</v-list-item-title>
            <v-list-item-subtitle
                class="accent--text"
                v-html="getNote(current)"
            ></v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn
                v-if="copyIsSupported"
                 class="mr-2"
                icon
                small
                :ripple="false"
                @click="copyNumber">
              <v-icon color="accent">mdi-content-copy</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </div>
    </div>

    <v-radio-group
        v-else
        :value="selectedId"
    >
      <v-radio v-for="opt in options"
               :key="opt.id"
               class="text--primary my-0"
               :value="opt.id"
               @click="selectOption(opt)"
      >
        <template slot="label">
          <v-list-item
              class="px-0"
              dense
          >
            <v-list-item-avatar size="30">
              <v-icon>{{getTypeLocalized(opt).icon}}</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="expanded">{{getValue(opt)}}</v-list-item-title>
              <v-list-item-subtitle v-html="getNote(opt)" class="expanded"></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-radio>
    </v-radio-group>
  </div>

</template>

<script>
import {types} from '@/constants'
import {copyToClipboard, getPaymentInfoTitle, replaceToBr} from '@/services/utils'

export default {
  name: 'PaymentConfirmationOptionSelector',
  computed: {
    copyIsSupported () {
      return this.current && this.current.type !== types.paymentInfo.cash.id
    }
  },
  created () {
    this.current = this.selectedId ? this.options.filter(val => val.id === this.selectedId)[0] : null
  },
  data () {
    return {
      current: null
    }
  },
  methods: {
    copyNumber (event) {
      event.stopPropagation()
      copyToClipboard(this.current.value)
    },
    getNote (info) {
      return replaceToBr(info.note)
    },
    getTypeLocalized (info) {
      return types.paymentInfo[info.type]
    },
    getValue (info) {
      return getPaymentInfoTitle(info)
    },
    selectOption (info) {
      this.current = info
      this.$emit('change', info.id)
    }
  },
  props: {
    options: {
      required: true,
      type: Array
    },
    selectedId: {
      type: String
    }
  }
}
</script>

<style scoped>

</style>